var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('p',{staticClass:"font-16 font-weight-bold mb-n2"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }